module.exports = __webpack_public_path__ + "img/TractionMpos3.e0485b16.png";